import "lazysizes"
import "picturefill"
// var $ = require('jQuery');

// WordPressはjQueryをnoConflictモードで動かすことがあり、グローバルの $ は当てにならない。
// slickはロード時のグローバル jQuery に登録されるため、同じ実体を $ として受け取っておく。
(function ($) {

  // スクロール表示アニメーションの発火位置。
  // 要素がビューポート下端からこの割合ぶん内側に入った時点で再生する。
  // 数字を大きくするほど遅く（画面の上のほうまで来てから）発火する。
  // 一筆書き・カウントアップ・フェードインで共通に使い、ここ1箇所で調整できるようにしている
  var REVEAL_OFFSET_PERCENT = 28
  var REVEAL_MARGIN = '0px 0px -' + REVEAL_OFFSET_PERCENT + '% 0px'

  // スムーススクロール
  // 移動そのものはブラウザ標準に任せる。
  // CSSの html{scroll-behavior:smooth} と [id]{scroll-margin-top} が効くため、
  // なめらかな移動もヘッダー分のオフセットもCSS側で完結する。
  //
  // 以前はjQueryの animate({scrollTop}) を併用していたが、
  // ブラウザ側のスムーススクロールが animate の書き込むスクロール位置を
  // 1フレームごとに追いかける形になり、0.5秒で終わるはずの移動に
  // 4〜5秒かかっていた（フェードイン待ちに見えていた症状の原因）。
  //
  // リンク未設定のプレースホルダ（href="#"）だけは、
  // ページ先頭へ飛んでしまわないよう既定の動作を止める。
  $('a[href^="#"]').on('click', function (e) {
    var href = $(this).attr('href')
    if (!href || href === '#') e.preventDefault()
  })

//アコーディオン
$('.js-menu__item__link').each(function () {
  $(this).on('click', function () {
    $("+.system__box,+.system__box--s,+.que__box", this).slideToggle();
    $(this).toggleClass("is-active")
    return false;
  });
});

//ヘッダーメニュー
$(".header__sp__btn, .header__spmenu__closebtn, .header__spmenu__item").on(
  "click",
  function () {
    $("html").toggleClass("scroll-prevent");
    if ($(".header__sp__btn").hasClass("is-active")) {
      $(".header__sp__btn").removeClass("is-active");
      $(".header__spmenu").removeClass("is-active");
      $(".header__spmenu__header").removeClass("is-active");
    } else {
      $(".header__sp__btn").addClass("is-active");
      $(".header__spmenu").addClass("is-active");
      $(".header__spmenu__header").addClass("is-active");
    }
  }
);


// 数字で見る（実績）スライダー
// SPのみスライダー、PCは折り返しグリッド。
// slickのresponsiveはbreakpoint以下に設定を当てる仕様で「PCだけunslick」を表現できないため、
// matchMediaで初期化と破棄を切り替える。
;(function () {
  var $list = $('.js-achieve__list')
  if (!$list.length) return

  var options = {
    slidesToShow: 1,
    slidesToScroll: 1,
    // 左右の隣カードを覗かせるデザインなのでcenterModeを使う
    centerMode: true,
    // 375px幅でカードがPCと同じ約210px幅になる値。狭いと帯のタイトルが2行に折り返してカードの高さが揃わない
    centerPadding: '20%',
    // infinite: false,
    // 矢印はpug側のボタンを使うのでslickには生成させない
    arrows: false,
    dots: true,
    appendDots: $('.js-achieve__dots'),
    swipeToSlide: true
  }

  var mq = window.matchMedia('(max-width: 834px)')

  var toggle = function () {
    if (mq.matches) {
      if (!$list.hasClass('slick-initialized')) $list.slick(options)
    } else {
      if ($list.hasClass('slick-initialized')) $list.slick('unslick')
    }
  }

  $('.js-achieve__prev').on('click', function () {
    if ($list.hasClass('slick-initialized')) $list.slick('slickPrev')
  })
  $('.js-achieve__next').on('click', function () {
    if ($list.hasClass('slick-initialized')) $list.slick('slickNext')
  })

  toggle()
  if (mq.addEventListener) {
    mq.addEventListener('change', toggle)
  } else {
    mq.addListener(toggle)
  }
})()


// TOP コラムのスライダー（PC・SPともループする）
// PC：左端をそろえて右側へ次のカードを並べ、はみ出した分は画面の端まで見せる（位置は「03 / 10」で表示）
// SP：中央のカードの左右に隣を覗かせ、ドットで位置を表示
// 設定がPCとSPで大きく違うので、matchMediaで切り替えのたびに作り直す
;(function () {
  var $list = $('.js-columnTop__list')
  if (!$list.length) return

  var $count = $('.js-columnTop__count')
  var $prev = $('.js-columnTop__prev')
  var $next = $('.js-columnTop__next')
  var mq = window.matchMedia('(max-width: 834px)')

  var pad = function (n) { return (n < 10 ? '0' : '') + n }

  // 位置表示（ループするので矢印は常に押せる）
  var update = function (slick, current) {
    $count.text(pad(current + 1) + ' / ' + pad(slick.slideCount))
  }

  var options = function () {
    var base = {
      arrows: false,
      swipeToSlide: true,
      infinite: true,
      // カードの幅はCSSで固定（PC 250px / SP 170px）
      variableWidth: true
    }
    if (mq.matches) {
      return $.extend(base, {
        centerMode: true,
        dots: true,
        appendDots: $('.js-columnTop__dots')
      })
    }
    return $.extend(base, { dots: false })
  }

  $list.on('init reInit afterChange', function (e, slick, current) {
    update(slick, typeof current === 'number' ? current : slick.currentSlide)
  })

  var build = function () {
    if ($list.hasClass('slick-initialized')) $list.slick('unslick')
    $('.js-columnTop__dots').empty()
    $list.slick(options())
  }

  $prev.on('click', function () { $list.slick('slickPrev') })
  $next.on('click', function () { $list.slick('slickNext') })

  build()
  if (mq.addEventListener) {
    mq.addEventListener('change', build)
  } else {
    mq.addListener(build)
  }
})()


// サービスの OVERVIEW スライダー
// 数字で見るマークと同じく、SPのみスライダーでPCは折り返しグリッド。
// 1ページに複数あるため、送りボタンとドットはそれぞれの OVERVIEW の中から探す
;(function () {
  var $lists = $('.js-overviewSlider')
  if (!$lists.length) return

  var mq = window.matchMedia('(max-width: 834px)')

  $lists.each(function () {
    var $list = $(this)
    var $box = $list.closest('.service__region__overview')

    var options = {
      slidesToShow: 1,
      slidesToScroll: 1,
      // 左右の隣のカードを覗かせる
      centerMode: true,
      centerPadding: '30px',
      // 矢印はpug側のボタンを使うのでslickには生成させない
      arrows: false,
      dots: true,
      appendDots: $box.find('.js-overviewSlider__dots'),
      swipeToSlide: true
    }

    var toggle = function () {
      if (mq.matches) {
        if (!$list.hasClass('slick-initialized')) $list.slick(options)
      } else {
        if ($list.hasClass('slick-initialized')) $list.slick('unslick')
      }
    }

    $box.find('.js-overviewSlider__prev').on('click', function () {
      if ($list.hasClass('slick-initialized')) $list.slick('slickPrev')
    })
    $box.find('.js-overviewSlider__next').on('click', function () {
      if ($list.hasClass('slick-initialized')) $list.slick('slickNext')
    })

    toggle()
    if (mq.addEventListener) {
      mq.addEventListener('change', toggle)
    } else {
      mq.addListener(toggle)
    }
  })
})()


// ロゴ描画アニメーション（parts/logo-anim.php）
// ページ内に複数設置でき、それぞれ画面に入った時点で1回だけ再生する。
// MVは最初から画面内にあるため、実質「初期表示時に再生」になる。
;(function () {
  var nodes = document.querySelectorAll('.js-logoAnim')
  // GSAPはCDN読み込みなので、失敗していても他の処理を巻き込まないよう抜ける
  if (!nodes.length || typeof gsap === 'undefined') return

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  var lineStart = { x: 26.5993, y: 70.5835 }
  var dotTarget = { x: 0, y: 92 }

  var setup = function (svg) {
    var line = svg.querySelector('.js-logoAnim__line')
    var dot = svg.querySelector('.js-logoAnim__dot')
    if (!line || !dot) return null

    var length = line.getTotalLength()
    gsap.set(line, { strokeDasharray: length, strokeDashoffset: length })

    // OS側でアニメーション低減を選んでいる場合は、描き終わった状態で静止させる
    if (reduce) {
      gsap.set(line, { strokeDashoffset: 0 })
      gsap.set(dot, { attr: { cx: dotTarget.x, cy: dotTarget.y } })
      return null
    }

    // 変形の中心をドットの真ん中に固定しておく（着地時に一時的に底面基準へ切り替える）
    gsap.set(dot, { attr: { cx: lineStart.x, cy: lineStart.y }, scale: 1, scaleX: 1, scaleY: 1, transformOrigin: 'center center' })
    return { line: line, dot: dot, length: length }
  }

  var play = function (ctx) {
    var line = ctx.line
    var dot = ctx.dot
    var length = ctx.length
    var tl = gsap.timeline()

    // 1. 線を進行方向へ描画
    tl.to(line, { strokeDashoffset: 0, duration: 1.5, ease: 'power2.inOut' }, 0)

    // 2. ドットを線の上に追従させる。
    // tween.progress() は等速の進み具合なので、線と同じイージングを掛けた値を別オブジェクトで進め、
    // 線の先端とドットが完全に同期するようにする
    var progressObj = { value: 0 }
    tl.to(progressObj, {
      value: 1,
      duration: 1.5,
      ease: 'power2.inOut',
      onUpdate: function () {
        var point = line.getPointAtLength(length * progressObj.value)
        dot.setAttribute('cx', point.x)
        dot.setAttribute('cy', point.y)
      }
    }, 0)

    // 3. 終点での踏み切り（溜め）
    tl.to(dot, { scale: 0.7, duration: 0.12, ease: 'power1.in' })

    // 4. 放物線を描いて最終地点へ飛ぶ
    var endPoint = line.getPointAtLength(length)
    tl.to(dot, {
      duration: 0.65,
      ease: 'power1.out',
      onUpdate: function () {
        var p = this.progress()
        var currentX = endPoint.x + (dotTarget.x - endPoint.x) * p
        var currentY = endPoint.y + (dotTarget.y - endPoint.y) * p
        var jumpHeight = Math.sin(p * Math.PI) * 80
        dot.setAttribute('cx', currentX)
        dot.setAttribute('cy', currentY - jumpHeight)
      }
    })

    // 飛行中の拡大・縮小（着地直前に少しサイズを戻す）
    tl.to(dot, { scale: 1.6, duration: 0.3, ease: 'power1.out' }, '<')
      .to(dot, { scale: 1.0, duration: 0.35, ease: 'power1.in' })

    // 5. 自然な着地バウンス（底面基準で潰してからポヨンと戻る）
    tl.to(dot, {
      // 地面に接する底面を基準にする
      transformOrigin: '50% 100%',
      scaleX: 1.35,
      scaleY: 0.65,
      duration: 0.08,
      ease: 'power2.out'
    })
      // 反動で少し上に伸びる
      .to(dot, { scaleX: 0.9, scaleY: 1.1, duration: 0.15, ease: 'power1.inOut' })
      .to(dot, { scaleX: 1, scaleY: 1, duration: 0.25, ease: 'power2.out' })
      // 最後に基準点を中心に戻す。拡縮が 1 に戻ってから切り替えないと、
      // GSAP が位置を保つために入れる補正が残り、ドットが最終位置から 1.4 ほどずれる
      .set(dot, { transformOrigin: 'center center' })
  }

  var contexts = []
  Array.prototype.forEach.call(nodes, function (svg) {
    var ctx = setup(svg)
    if (ctx) contexts.push({ svg: svg, ctx: ctx })
  })
  if (!contexts.length) return

  if (!window.IntersectionObserver) {
    contexts.forEach(function (c) { play(c.ctx) })
    return
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return
      // 繰り返さないので、再生したら監視を外す
      io.unobserve(entry.target)
      for (var i = 0; i < contexts.length; i++) {
        if (contexts[i].svg === entry.target) { play(contexts[i].ctx); break }
      }
    })
  }, { rootMargin: REVEAL_MARGIN })

  contexts.forEach(function (c) { io.observe(c.svg) })
})()


// SERVICEの手描き風ライン：一筆書きアニメーション
// このSVGは stroke を持つパスではなく、ブラシの粒（1つの図形）を <use> で数百個並べ、
// 全体にぼかし（feGaussianBlur）を掛けた構造。粒を DOM 上で1つずつ表示すると
// 毎フレームぼかしを掛け直すことになりスマホでカクつく。
// そこで粒を canvas に描画順どおり描き足していき（毎フレーム描くのは新しく増えた粒だけ）、
// ぼかしと不透明度は canvas 要素への CSS filter / opacity で再現する（GPU 合成で軽い）。
// 粒の図形・座標を得るためにSVGファイルは取得するが、DOMには差し込まない
;(function () {
  var wrap = document.querySelector('.js-service__line')
  if (!wrap || !window.fetch || typeof Path2D === 'undefined') return

  var img = wrap.querySelector('img')
  if (!img) return

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  var mq = window.matchMedia('(min-width: 835px)')
  var currentSrc = ''
  var track = null // { parts: 粒の並び, path: 粒の図形, fill, opacity, blur, vb: viewBox }
  var inView = false
  var played = false

  // 各サービスの円。線がその円に到達した時点で1つずつ出す
  var main = wrap.parentNode
  var items = main ? main.querySelectorAll('.service__item') : []

  // 線が円に届いてから出すまでの間と、円どうしの最小間隔（ms）。
  // 線に完全同期させると6つが0.3秒ほどで出切ってしまうので、少し遅らせて1つずつ見せる
  var ITEM_DELAY = 200
  var ITEM_GAP = 150

  var showItems = function () {
    for (var i = 0; i < items.length; i++) items[i].classList.remove('is-waiting')
  }

  // 線が届いた円を予約し、時間が来たものから出す。戻り値は「まだ出ていない円があるか」
  var lastDue = 0
  var revealItems = function (upTo, now) {
    var pending = false
    for (var i = 0; i < items.length; i++) {
      var el = items[i]
      if (!el.classList.contains('is-waiting')) continue
      if (el.__due === undefined && el.__lineIndex <= upTo) {
        el.__due = Math.max(now + ITEM_DELAY, lastDue + ITEM_GAP)
        lastDue = el.__due
      }
      if (el.__due !== undefined && now >= el.__due) {
        el.classList.remove('is-waiting')
      } else {
        pending = true
      }
    }
    return pending
  }

  // 描く前に完成形の <img> が見えてしまわないよう、取得を待つ間は伏せておく
  // （失敗したら戻して画像を出す）
  if (!reduce) {
    wrap.classList.add('is-preparing')
    for (var k = 0; k < items.length; k++) items[k].classList.add('is-waiting')
  }

  // SVGテキストから、粒の図形と、各粒の位置・大きさ・回転を描画順に取り出す
  var parseTrack = function (text) {
    var doc = new DOMParser().parseFromString(text, 'image/svg+xml')
    var svg = doc.querySelector('svg')
    if (!svg) return null
    var vb = (svg.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number)
    if (vb.length !== 4) return null

    // 粒の図形（<use> が参照している <g id> の中の path）
    var uses = svg.querySelectorAll('use')
    if (uses.length < 2) return null
    var ref = (uses[0].getAttribute('xlink:href') || uses[0].getAttribute('href') || '').replace('#', '')
    var symbol = ref ? doc.getElementById(ref) : null
    var shape = symbol && symbol.querySelector('path')
    if (!shape) return null

    var parts = []
    for (var i = 0; i < uses.length; i++) {
      var t = uses[i].getAttribute('transform') || ''
      var tr = t.match(/translate\(([-\d.e]+)[ ,]+([-\d.e]+)\)/)
      var mx = t.match(/matrix\(([-\d.e]+)[ ,]+([-\d.e]+)[ ,]+([-\d.e]+)[ ,]+([-\d.e]+)[ ,]+([-\d.e]+)[ ,]+([-\d.e]+)\)/)
      var sc = t.match(/scale\(([-\d.e]+)\)/)
      var ro = t.match(/rotate\(([-\d.e]+)\)/)
      if (tr) {
        parts.push({ x: +tr[1], y: +tr[2], s: sc ? +sc[1] : 1, r: ro ? +ro[1] : 0 })
      } else if (mx) {
        // 先頭の粒は matrix(0 0 0 0 x y)（大きさ0）で来る。位置だけ使う
        parts.push({ x: +mx[5], y: +mx[6], s: Math.sqrt(+mx[1] * +mx[1] + +mx[2] * +mx[2]), r: 0 })
      } else {
        return null
      }
    }

    // <g opacity filter> の不透明度と、ぼかし量（viewBox座標）
    var group = uses[0].parentNode
    var opacity = group && group.getAttribute('opacity') ? +group.getAttribute('opacity') : 1
    var blurEl = doc.querySelector('feGaussianBlur')
    var blur = blurEl ? +(blurEl.getAttribute('stdDeviation') || 0) : 0

    return {
      parts: parts,
      path: new Path2D(shape.getAttribute('d')),
      fill: shape.getAttribute('fill') || '#F78800',
      opacity: opacity,
      blur: blur,
      vb: vb
    }
  }

  // 各円について「線が最初に円の中（半径×1.1）に入る粒の番号」を求める。
  // 線は円の中心を通るとは限らないので、見つからなければ最も近づく粒で代用する
  var assignItemIndexes = function (canvas) {
    var rect = canvas.getBoundingClientRect()
    var sx = rect.width / track.vb[2]
    var sy = rect.height / track.vb[3]
    for (var j = 0; j < items.length; j++) {
      var r = items[j].getBoundingClientRect()
      var cx = r.left + r.width / 2
      var cy = r.top + r.height / 2
      var limit = r.width / 2 * 1.1
      var first = -1
      var nearest = 0
      var nearestD = Infinity
      for (var n = 0; n < track.parts.length; n++) {
        var x = rect.left + (track.parts[n].x - track.vb[0]) * sx
        var y = rect.top + (track.parts[n].y - track.vb[1]) * sy
        var d = Math.sqrt(Math.pow(x - cx, 2) + Math.pow(y - cy, 2))
        if (d < nearestD) { nearestD = d; nearest = n }
        if (first < 0 && d <= limit) first = n
      }
      items[j].__lineIndex = first >= 0 ? first : nearest
    }
  }

  // 描き終わったら元の <img>（完成形）を出し、canvas は同じフレームで外す。
  // フェードで重ねると、半透明の線が2枚重なって一瞬明るく光って見えるため即時に切り替える
  var finish = function (canvas) {
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas)
    wrap.classList.remove('is-drawing')
    wrap.classList.remove('is-preparing')
  }

  var draw = function () {
    if (!track || played || reduce) return
    played = true

    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext && canvas.getContext('2d')
    if (!ctx) { finish(null); showItems(); return }

    // <img> と同じ大きさで重ねる。高解像度端末は2倍まで（それ以上は描画コストに見合わない）
    var cssW = img.clientWidth || wrap.clientWidth
    var cssH = img.clientHeight || Math.round(cssW * track.vb[3] / track.vb[2])
    var dpr = Math.min(window.devicePixelRatio || 1, 2)
    canvas.width = Math.round(cssW * dpr)
    canvas.height = Math.round(cssH * dpr)
    canvas.style.width = cssW + 'px'
    canvas.style.height = cssH + 'px'
    // SVG の <g opacity filter="blur"> を canvas 要素への CSS で再現する（ぼかし量は表示倍率に合わせる）
    canvas.style.opacity = String(track.opacity)
    if (track.blur) canvas.style.filter = 'blur(' + (track.blur * cssW / track.vb[2]).toFixed(2) + 'px)'
    canvas.setAttribute('aria-hidden', 'true')
    wrap.appendChild(canvas)
    wrap.classList.add('is-drawing')
    wrap.classList.remove('is-preparing')

    assignItemIndexes(canvas)

    // viewBox座標 → canvas座標
    var sx = canvas.width / track.vb[2]
    var sy = canvas.height / track.vb[3]
    var total = track.parts.length
    var duration = 3200
    var start = null
    var drawn = 0

    ctx.fillStyle = track.fill

    // 粒 drawn〜count-1 を描き足す（描いた粒は消さないので、毎フレームの処理は増えた分だけ）
    var render = function (count) {
      for (; drawn < count; drawn++) {
        var pt = track.parts[drawn]
        if (!pt.s) continue
        ctx.setTransform(sx, 0, 0, sy, -track.vb[0] * sx, -track.vb[1] * sy)
        ctx.translate(pt.x, pt.y)
        ctx.scale(pt.s, pt.s)
        ctx.rotate(pt.r * Math.PI / 180)
        ctx.fill(track.path)
      }
    }

    var step = function (ts) {
      if (start === null) start = ts
      var p = Math.min((ts - start) / duration, 1)
      // 終盤をゆるめて筆が抜ける感じにする
      var eased = 1 - Math.pow(1 - p, 2)
      var shown = p >= 1 ? total : Math.floor(eased * total)
      render(shown)
      // 線が届いた円を、少し遅れて順に出す。線を描き終えても、円が出切るまでは回し続ける
      var pending = revealItems(shown - 1, ts)
      if (p < 1 || pending) {
        window.requestAnimationFrame(step)
      } else {
        finish(canvas)
      }
    }
    window.requestAnimationFrame(step)
  }

  var inject = function () {
    // currentSrc は <picture> の media 判定を経た実際の読み込み先
    var src = img.currentSrc || img.src
    if (!src || src === currentSrc) return
    currentSrc = src

    // 再生済みならファイルが変わっても描き直さない（画像はブラウザが差し替える）
    if (played) return

    fetch(src)
      .then(function (res) { return res.ok ? res.text() : Promise.reject() })
      .then(function (text) {
        var parsed = parseTrack(text)
        if (!parsed) return Promise.reject()
        track = parsed
        if (inView) draw()
      })
      .catch(function () {
        // 取得・解析できなければ元の画像を出し、円も待たせずに出す
        wrap.classList.remove('is-preparing')
        showItems()
      })
  }

  // 取得は読み込み直後に済ませ、再生だけを画面内に入った時点で行う。
  // ただし currentSrc は画像の読み込みが済むまで空なので、そのまま実行すると
  // src属性(=SP用ファイル)にフォールバックし、PCでもSP用SVGを解析してしまう
  if (img.complete && (img.currentSrc || '') !== '') {
    inject()
  } else {
    img.addEventListener('load', inject)
    // 画像自体が読めなくてもSVG取得は試す（srcは属性値で確定しているため）
    img.addEventListener('error', inject)
  }

  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return
      io.disconnect()
      inView = true
      draw()
    }, { rootMargin: REVEAL_MARGIN })
    io.observe(wrap)
  } else {
    inView = true
    draw()
  }

  // ブレークポイントをまたいだら <picture> が別ファイルを選ぶので、まだ再生前なら解析し直す
  var onChange = function () { inject() }
  if (mq.addEventListener) {
    mq.addEventListener('change', onChange)
  } else {
    mq.addListener(onChange)
  }
})()


// 「ご相談からお見積りまで」の縦ライン。
// スクロールに合わせて青い進捗を伸ばし、通過した段のアイコンを点灯させる
;(function () {
  var root = document.querySelector('.js-guide__flow')
  if (!root) return

  var line = root.querySelector('.guide__flow__line')
  var bar = root.querySelector('.js-guide__flow__progress')
  var items = Array.prototype.slice.call(root.querySelectorAll('.guide__flow__item'))
  if (!line || !bar || items.length < 2) return

  // 進捗を判定する基準線を、画面の高さに対する割合で決める。
  // 小さくするほど基準線が画面の上寄りになり、その位置まで
  // スクロールしないと進まないので、点灯は遅くなる
  var REF_RATIO = 0.45

  var centers = []
  var startY = 0
  var endY = 0

  // ラインは最初のアイコンの中心から最後のアイコンの中心まで。
  // 段ごとにカードの高さが違うので、位置は決め打ちにせず実測する
  var measure = function () {
    var rootTop = root.getBoundingClientRect().top + window.pageYOffset
    centers = items.map(function (item) {
      var icon = item.querySelector('.guide__flow__icon')
      var r = icon.getBoundingClientRect()
      return r.top + window.pageYOffset + r.height / 2
    })
    startY = centers[0]
    endY = centers[centers.length - 1]
    line.style.top = (startY - rootTop) + 'px'
    line.style.height = (endY - startY) + 'px'
  }

  var update = function () {
    var ref = window.pageYOffset + window.innerHeight * REF_RATIO
    var span = endY - startY
    var p = span > 0 ? (ref - startY) / span : 0
    if (p < 0) p = 0
    if (p > 1) p = 1
    bar.style.height = (p * 100) + '%'

    items.forEach(function (item, i) {
      if (centers[i] <= ref) {
        item.classList.add('is-active')
      } else {
        item.classList.remove('is-active')
      }
    })
  }

  var refresh = function () {
    measure()
    update()
  }

  refresh()
  window.addEventListener('scroll', update, { passive: true })
  window.addEventListener('resize', refresh)
  // フォントや画像が後から効いて高さが変わることがあるので測り直す
  window.addEventListener('load', refresh)
  if (window.ResizeObserver) new window.ResizeObserver(refresh).observe(root)
})()


// ヘッダーの背景。ページ上端から離れたら白くする
;(function () {
  var header = document.querySelector('.header')
  if (!header) return

  // 切り替え位置はヘッダーの高さぶん。PC/SPで高さが違うので固定値にせず都度見る
  var onScroll = function () {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0
    var scrolled = y > (header.offsetHeight || 64)
    // 背景が変わっても高さは変わらないため、行ったり来たりはしない
    if (scrolled) {
      header.classList.add('is-active')
    } else {
      header.classList.remove('is-active')
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
  // リロードやアンカー遷移で途中から表示された場合にも合わせる
  onScroll()
})()


// 「数字で見る」の数値カウントアップ（画面に入った時点で1回だけ）
// TOPと下層(マークについて)の両方に置かれるため、ページ固有のクラスには依存せず、
// 数字要素から最も近い section をまとめ単位として扱う
;(function () {
  var nums = document.querySelectorAll('.achieve__item__num strong')
  if (!nums.length) return

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  // 同じセクションに属する数字をひとまとめにする
  var groups = []
  Array.prototype.forEach.call(nums, function (el) {
    var target = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10)
    if (isNaN(target)) return

    var section = el.closest('section') || el.closest('div') || document.body
    var group = null
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].section === section) { group = groups[i]; break }
    }
    if (!group) {
      group = { section: section, items: [] }
      groups.push(group)
    }
    group.items.push({ el: el, target: target })
  })
  if (!groups.length) return

  // OS側でアニメーション低減を選んでいる場合は最終値のまま動かさない
  if (reduce) return

  // 数え始めるまでの間に最終値がちらついて見えないよう、先に0にしておく。
  // あわせて、桁数が増える過程で右側がずれないよう最終値の幅を確保する
  var prime = function (items) {
    items.forEach(function (it) {
      it.el.style.minWidth = it.el.offsetWidth + 'px'
      it.el.textContent = '0'
    })
  }

  // 数字が0のまま待っているのが見えないよう、まだ数え始めていない段はカードごと伏せる
  var cardOf = function (it) {
    return it.el.closest('.achieve__item')
  }
  var hideRow = function (items) {
    items.forEach(function (it) {
      var card = cardOf(it)
      if (card) card.classList.add('is-waiting')
    })
  }
  var showRow = function (items) {
    items.forEach(function (it) {
      var card = cardOf(it)
      if (card) card.classList.remove('is-waiting')
    })
  }

  var run = function (items, done) {
    var duration = 2200
    var start = null

    var step = function (ts) {
      if (start === null) start = ts
      var p = Math.min((ts - start) / duration, 1)
      // 終盤を緩めて、数字が吸い付くように止める
      var eased = 1 - Math.pow(1 - p, 3)
      items.forEach(function (it) {
        it.el.textContent = String(Math.round(it.target * eased))
      })
      if (p < 1) {
        window.requestAnimationFrame(step)
      } else {
        items.forEach(function (it) {
          it.el.textContent = String(it.target)
          it.el.style.minWidth = ''
        })
        if (done) done()
      }
    }
    window.requestAnimationFrame(step)
  }

  // 描画位置から段を割り出す。1行あたりの個数はCSSの折り返し任せなので、
  // 数を決め打ちにせず実際の位置で判定するほうがレイアウト変更に強い。
  // SPはスライダーで横一列に並ぶため、自然に1段として扱われる
  var rowsOf = function (items) {
    var rows = []
    items.forEach(function (it) {
      var top = Math.round(it.el.getBoundingClientRect().top)
      var row = null
      for (var i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].top - top) <= 8) { row = rows[i]; break }
      }
      if (!row) {
        row = { top: top, items: [] }
        rows.push(row)
      }
      row.items.push(it)
    })
    rows.sort(function (a, b) { return a.top - b.top })
    return rows
  }

  // 段ごとに、前の段が数え終わってから次の段を動かす
  // 次の段を動かし始めるまでの間隔（ミリ秒）。
  // 前の段が数え終わる（約2.2秒）のを待つと遅く感じるため、途中から重ねて始める。
  // 小さくするほど2段目が早く出る
  var ROW_STAGGER = 800

  var runInRows = function (items) {
    var rows = rowsOf(items)
    // 2段目以降は、その段の番が来るまで伏せておく（1段目はそのまま出す）
    rows.slice(1).forEach(function (row) { hideRow(row.items) })

    rows.forEach(function (row, i) {
      window.setTimeout(function () {
        // カードのフェードインと数え上げを同時に始める
        showRow(row.items)
        run(row.items)
      }, i * ROW_STAGGER)
    })
  }

  // カウントを始める不透明度のしきい値。
  // 画面に入った時点で始めると見える前に数え終わってしまい、
  // フェード完了まで待つと動き出しが遅く感じる。その中間で走り出させる。
  // 小さくするほど早く、大きくするほど遅くなる
  var COUNT_START_OPACITY = 0.35

  // フェードインの対象に入っている場合は、ある程度見えてきてから数え始める
  var whenVisible = function (el, cb) {
    var host = el.closest('.u-reveal')
    if (!host) {
      cb()
      return
    }
    var t0 = Date.now()
    var check = function () {
      var opacity = parseFloat(window.getComputedStyle(host).opacity)
      // 何らかの理由で不透明度が上がらなくても、数字が0のまま残らないようにする
      if (opacity >= COUNT_START_OPACITY || Date.now() - t0 > 4000) {
        cb()
        return
      }
      window.requestAnimationFrame(check)
    }
    check()
  }

  // 2段目以降は読み込み時点で伏せておく。数え始める直前に伏せると、
  // それまでの間（セクションのフェードイン中など）に一瞬見えてしまうため。
  // 伏せる瞬間にフェードアウトが見えないよう、この時だけトランジションを切る
  groups.forEach(function (g) {
    rowsOf(g.items).slice(1).forEach(function (row) {
      row.items.forEach(function (it) {
        var card = cardOf(it)
        if (!card) return
        card.style.transition = 'none'
        card.classList.add('is-waiting')
        void card.offsetWidth
        card.style.transition = ''
      })
    })
  })

  // SPではスライダー内にあり、画面外のスライドは判定されにくい。
  // セクション単位で監視して、そのセクションの数値を一斉に動かす
  if (!window.IntersectionObserver) {
    groups.forEach(function (g) {
      prime(g.items)
      runInRows(g.items)
    })
    return
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return
      io.unobserve(entry.target)
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].section !== entry.target) continue
        var items = groups[i].items
        // 待っている間に最終値が見えないよう、この時点で0にしておく
        prime(items)
        whenVisible(items[0].el, function () { runInRows(items) })
        break
      }
    })
  }, { rootMargin: REVEAL_MARGIN })

  groups.forEach(function (g) { io.observe(g.section) })
})()


// 見出しを1文字ずつに分割する（.u-chars）
// 実際の再生は .u-reveal の監視で .is-revealed が付いたときにCSS側で走るため、
// このブロックは必ず .u-reveal の処理より前に実行しておく
;(function () {
  var els = document.querySelectorAll('.u-chars')
  if (!els.length) return

  var CHAR_STEP = 70

  // 直下のテキストノードだけを対象にする。中の span（装飾の点）や em（和文）は触らない
  var split = function (el) {
    var chars = []
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeType !== 3) return
      var text = node.nodeValue
      if (!text || !text.trim()) return

      var frag = document.createDocumentFragment()
      for (var i = 0; i < text.length; i++) {
        var ch = text.charAt(i)
        if (ch === ' ') {
          // 半角スペースは分割せず、潰れないよう固定幅にする
          frag.appendChild(document.createTextNode('\u00a0'))
          continue
        }
        var span = document.createElement('span')
        span.className = 'u-chars__item'
        span.textContent = ch
        frag.appendChild(span)
        chars.push(span)
      }
      el.replaceChild(frag, node)
    })
    return chars
  }

  // background-clip:text の見出しは、親の背景を文字が透かして見せている。
  // 文字を span に分けても opacity は効かない（見えているのは親の背景のため）ので、
  // 各文字に同じグラデーションを持たせ、位置をずらして連続した見た目を保つ
  var applyGradient = function (item) {
    var width = item.el.clientWidth
    item.chars.forEach(function (c) {
      c.style.backgroundImage = item.bg
      c.style.backgroundSize = width + 'px 100%'
      c.style.backgroundPosition = (-c.offsetLeft) + 'px 0'
      c.style.webkitBackgroundClip = 'text'
      c.style.backgroundClip = 'text'
    })
  }

  var items = []

  Array.prototype.forEach.call(els, function (el) {
    var chars = split(el)
    if (!chars.length) return

    var base = parseInt(el.getAttribute('data-reveal-delay') || '0', 10) || 0
    chars.forEach(function (c, i) {
      c.style.transitionDelay = (base + i * CHAR_STEP) + 'ms'
    })

    var cs = window.getComputedStyle(el)
    var clip = cs.webkitBackgroundClip || cs.backgroundClip
    var bg = cs.backgroundImage
    var item = { el: el, chars: chars, bg: bg }

    // offsetLeft が親基準になる場合のみ、背景位置の計算が成立する
    if (clip === 'text' && bg && bg !== 'none' && chars[0].offsetParent === el) {
      applyGradient(item)
      // 親の背景を残すと、動かない文字の影が二重に見えるため消す
      el.style.backgroundImage = 'none'
      item.gradient = true
    }
    items.push(item)
  })

  var onResize = function () {
    items.forEach(function (item) { if (item.gradient) applyGradient(item) })
  }
  window.addEventListener('resize', onResize)
})()


// スクロール表示アニメーション（.u-reveal を画面内で1度だけ下からフェードイン）
;(function () {
  var targets = document.querySelectorAll('.u-reveal')
  if (!targets.length) return

  var revealAll = function () {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-revealed') })
  }

  // 低減設定時やIntersectionObserver非対応時は、隠したままにせず即表示する
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.IntersectionObserver) {
    revealAll()
    return
  }

  // 同じ親に並ぶ要素は少しずつ遅らせ、順に立ち上がって見えるようにする。
  // data-reveal-delay があればそちらを優先し、任意の順序を組めるようにする
  Array.prototype.forEach.call(targets, function (el) {
    var explicit = el.getAttribute('data-reveal-delay')
    if (explicit !== null && explicit !== '') {
      el.style.transitionDelay = parseInt(explicit, 10) + 'ms'
      return
    }
    var siblings = el.parentNode.children
    var index = 0
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === el) break
      if (siblings[i].classList && siblings[i].classList.contains('u-reveal')) index++
    }
    if (index > 0) el.style.transitionDelay = Math.min(index, 5) * 150 + 'ms'
  })

  // 出し終わったら .u-reveal を外す。
  // 付けたままだと opacity/transform の指定がホバー演出と詳細度で競合し、
  // ホバーが効かない要素が出るため（例: .nav__main, .mv__btn）
  var settle = function (el) {
    var delay = parseInt(el.style.transitionDelay, 10) || 0
    window.setTimeout(function () {
      el.classList.remove('u-reveal')
      el.classList.remove('u-reveal--fade')
      el.style.transitionDelay = ''
    }, delay + 2200)
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-revealed')
      // 繰り返さないので、出したら監視を外す
      io.unobserve(entry.target)
      // .u-chars は .is-revealed を残す必要があるため、外すのは .u-reveal 系だけ
      settle(entry.target)
    })
  }, { rootMargin: REVEAL_MARGIN })

  Array.prototype.forEach.call(targets, function (el) {
    // ファーストビューの演出（data-reveal-load）は、画面内の位置に関係なく読み込み時点から再生する。
    // 画面の低い端末ではMVのボタンなどが発火ラインより下に来て、スクロールするまで出なくなるため
    if (el.hasAttribute('data-reveal-load')) {
      el.classList.add('is-revealed')
      settle(el)
      return
    }
    io.observe(el)
  })
})()


// スクロールで浮かせる（.js-float）
// 画面の下端に入った時点で range ぶん下にずらし、上端へ近づくにつれて本来の位置へ戻す。
// さらに目標位置へは一気に動かさず毎フレーム少しずつ近づける（慣性）ので、
// スクロールを止めた後もふわっと遅れて追いつき、手前に浮いているように見える。
// 値は --float で渡し、CSS側（object/utility/float.styl）で translate にする
;(function () {
  var targets = document.querySelectorAll('.js-float')
  if (!targets.length) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  var mq = window.matchMedia('(min-width: 835px)')
  // 1フレームで目標との差のどれだけを詰めるか。小さいほど遅れが大きい（0.08 ≒ 60fps で約0.6秒で追いつく）
  var LERP = 0.08

  var state = []
  Array.prototype.forEach.call(targets, function (el) {
    state.push({ el: el, cur: null, target: 0 })
  })

  var apply = function (s) {
    s.el.style.setProperty('--float', s.cur.toFixed(2) + 'px')
  }

  // スクロール位置から各要素の目標値を求める。
  // getBoundingClientRect は浮遊ぶんの translate を含むので、その分を引いて本来の位置で計算する
  var measure = function () {
    var vh = window.innerHeight || document.documentElement.clientHeight
    // SPは画面が小さいぶん動きが目立つので控えめにする
    var range = mq.matches ? 120 : 25
    for (var i = 0; i < state.length; i++) {
      var s = state[i]
      var top = s.el.getBoundingClientRect().top - (s.cur || 0)
      // 画面より下にあるものは range（入ってきた瞬間に跳ねないよう最初から下げておく）、
      // 通り過ぎたものは 0 で止める
      var ratio = top / vh
      if (ratio < 0) ratio = 0
      if (ratio > 1) ratio = 1
      s.target = ratio * range
      // 初回は追いかけずに目標へ置く（読み込み直後に動いて見えないように）
      if (s.cur === null) { s.cur = s.target; apply(s) }
    }
  }

  var running = false
  var loop = function () {
    var active = false
    for (var i = 0; i < state.length; i++) {
      var s = state[i]
      var d = s.target - s.cur
      if (Math.abs(d) < 0.05) {
        if (s.cur !== s.target) { s.cur = s.target; apply(s) }
      } else {
        s.cur += d * LERP
        apply(s)
        active = true
      }
    }
    if (active) {
      window.requestAnimationFrame(loop)
    } else {
      running = false
    }
  }

  var onScroll = function () {
    measure()
    if (!running) {
      running = true
      window.requestAnimationFrame(loop)
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
  measure()
})()


// パララックス（スクロールに合わせて clip-image 内の画像をゆっくり上下させる）
// SVGの座標系で動かすため、CSSではなく transform 属性を書き換える
;(function () {
  var targets = document.querySelectorAll('.js-parallax')
  if (!targets.length) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  // clip-image は上下に80pxずつ余白を持たせてあるので、その範囲（80以下）に収める。
  // SPは画面が小さいぶん動きが目立つので控えめにする
  var mqPc = window.matchMedia('(min-width: 835px)')
  var rangeFor = function () { return mqPc.matches ? 80 : 35 }
  var ticking = false

  var update = function () {
    ticking = false
    var vh = window.innerHeight || document.documentElement.clientHeight

    Array.prototype.forEach.call(targets, function (el) {
      // getBoundingClientRect はSVG子要素でも使えるが、
      // 表示枠の位置が欲しいので外側のsvgを基準にする
      var host = el.ownerSVGElement || el
      var rect = host.getBoundingClientRect()
      if (rect.bottom < 0 || rect.top > vh) return

      // 要素の中心が画面中央から上下どれだけ離れているかを -1〜1 に正規化
      var center = rect.top + rect.height / 2
      var progress = (center - vh / 2) / (vh / 2 + rect.height / 2)
      if (progress > 1) progress = 1
      if (progress < -1) progress = -1

      el.setAttribute('transform', 'translate(0 ' + (progress * rangeFor()).toFixed(2) + ')')
    })
  }

  var onScroll = function () {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(update)
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
  update()
})()


// フッターナビのアコーディオン（SPのみ。PCはCSSで常時展開）
// inline styleを使うslideToggleではなくクラス切り替えにして、
// 開閉状態がブレークポイントをまたいで残らないようにする
;(function () {
  var toggles = document.querySelectorAll('.js-footer__nav__toggle')
  if (!toggles.length) return

  Array.prototype.forEach.call(toggles, function (toggle) {
    var item = toggle.closest('.footer__nav__item')
    if (!item) return
    var link = item.querySelector('.footer__nav__link')

    var setOpen = function (opened) {
      item.classList.toggle('is-open', opened)
      toggle.setAttribute('aria-expanded', opened ? 'true' : 'false')
      toggle.setAttribute('aria-label', 'サービスの下層メニューを' + (opened ? '閉じる' : '開く'))
    }

    // ボタンがCSSで隠れている = PC幅。そのときはリンクとして素通しする
    var isAccordion = function () {
      return window.getComputedStyle(toggle).display !== 'none'
    }

    toggle.addEventListener('click', function () {
      setOpen(!item.classList.contains('is-open'))
    })

    // 行のテキスト部分をタップしても開閉するようにする。
    // これが無いと href="#" が働いてページ先頭へスクロールしてしまう
    if (link) {
      link.addEventListener('click', function (e) {
        if (!isAccordion()) return
        e.preventDefault()
        setOpen(!item.classList.contains('is-open'))
      })
    }
  })
})()


// 画面に入ったら .is-inview を付けるだけの汎用フック（.js-inview）
// 見た目は各要素のCSSに任せるので、.u-reveal のように初期状態を持たない。
//
// IntersectionObserverは監視開始時の要素サイズで判定するため、
// 画像のように後から高さが決まる要素では取りこぼしが起きた。
// 対象が少数なので、スクロールのたびに自前で位置を測る方式にする（rAFで間引く）
;(function () {
  var targets = Array.prototype.slice.call(document.querySelectorAll('.js-inview'))
  if (!targets.length) return

  var ticking = false
  // 画像の読み込みが終わるまではページ全体が縮んでおり、下方の要素まで
  // 画面内に入っているように見えてしまう。レイアウトが確定するまで判定しない
  var ready = document.readyState === 'complete'

  var check = function () {
    ticking = false
    if (!ready) return
    var vh = window.innerHeight || document.documentElement.clientHeight

    targets = targets.filter(function (el) {
      var rect = el.getBoundingClientRect()
      // 上のIntersectionObserver勢と同じ位置で発火させる
      if (rect.bottom > 0 && rect.top < vh * (1 - REVEAL_OFFSET_PERCENT / 100)) {
        el.classList.add('is-inview')
        return false
      }
      return true
    })

    // 全部出し終わったら監視をやめる
    if (!targets.length) {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      window.removeEventListener('load', onScroll)
    }
  }

  var onScroll = function () {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(check)
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
  // 画像の高さが確定した時点で判定を解禁し、そこで一度測る
  window.addEventListener('load', function () {
    ready = true
    check()
  })
  check()
})()


// お問い合わせ「質問内容」の文字数制限（500文字）とカウンター
// CF7 の maxlength: は改行を2文字として数えて上限内でも弾いてしまうため使わず、
// ここで見た目どおりの文字数で制限する。サーバ側の同じチェックは inc/cf7.php（MARK_CF7_CONTENT_MAX）
;(function () {
  var CONTENT_MAX = 500
  var fields = document.querySelectorAll('.wpcf7-form textarea[name="content"]')
  if (!fields.length) return

  Array.prototype.forEach.call(fields, function (field) {
    var counter = document.createElement('span')
    counter.className = 'contact__form__count'
    counter.setAttribute('aria-live', 'polite')
    counter.innerHTML = '<b>0</b>/' + CONTENT_MAX
    var num = counter.querySelector('b')
    // CF7 の入力欄は span.wpcf7-form-control-wrap に包まれているので、その直後に置く
    var wrap = field.closest('.wpcf7-form-control-wrap') || field
    wrap.parentNode.insertBefore(counter, wrap.nextSibling)

    var composing = false

    var update = function () {
      // 変換中に切り詰めると入力が壊れるので、確定してから数える
      if (composing) return
      var value = field.value.replace(/\r\n?/g, '\n')
      if (value.length > CONTENT_MAX) {
        var start = field.selectionStart
        field.value = value.slice(0, CONTENT_MAX)
        // 切り詰めた位置より前にカーソルがあった場合はそのまま残す
        var pos = Math.min(start, CONTENT_MAX)
        try { field.setSelectionRange(pos, pos) } catch (e) {}
        value = field.value
      }
      num.textContent = value.length
      counter.classList.toggle('is-limit', value.length >= CONTENT_MAX)
    }

    field.addEventListener('compositionstart', function () { composing = true })
    field.addEventListener('compositionend', function () { composing = false; update() })
    field.addEventListener('input', update)
    field.addEventListener('change', update)
    // 確認画面から戻ったときなど、後から値が入るケースに備える
    window.addEventListener('load', update)
    document.addEventListener('wpcf7invalid', update)
    update()
  })
})()


// プライバシーポリシー同意欄のラベルをリンク付きに差し替える
// .wpcf7-list-item-label はお問い合わせ種別のラジオにも付くので、
// 同意欄(.contact__form__acceptance)の中だけに限定する
$(function () {
  $('.contact__form__acceptance .wpcf7-list-item-label').replaceWith(function () {
    return (
      `<span></span><p><a class="wpcf7-list-item-label" href="${pathUrl}/privacy" target="_blank">` +
      $(this).text() +
      `<img src="${pathSrc}/img/common/external-link.svg" alt=""/></a>について同意する</p>`
    )
  })
})

// FAQのアコーディオン
$(".faq__item__q").each(function () {
  $(this).on("click", function () {
    $("+div", this).slideToggle();
    $(this).toggleClass("is-active");
    return false;
  });
});


// 用語集「カテゴリーから探す」モーダル
;(function () {
  var modal = document.querySelector('.js-terminology__modal')
  if (!modal) return

  var openers = document.querySelectorAll('.js-terminology__modal__open')
  var closers = modal.querySelectorAll('.js-terminology__modal__close')
  if (!openers.length) return

  var lastFocused = null
  // CSSのtransitionと同じ長さ。閉じ切ってから hidden を付けるために使う
  var DURATION = 600

  var open = function (trigger) {
    lastFocused = trigger || document.activeElement
    modal.removeAttribute('hidden')
    // hidden を外した直後にクラスを付けても transition が走らないため、
    // 描画が1フレーム進むのを待ってから開いた状態にする
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { modal.classList.add('is-open') })
    })
    // 背面のページがスクロールしないようにする（ヘッダーメニューと同じ仕組み）
    document.documentElement.classList.add('scroll-prevent')
    Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', 'true') })
    // 開いた直後は閉じるボタンに焦点を移す
    var first = modal.querySelector('.js-terminology__modal__close')
    if (first) first.focus()
  }

  var close = function () {
    modal.classList.remove('is-open')
    document.documentElement.classList.remove('scroll-prevent')
    // フェードアウトが終わってから hidden を付ける（途中で再度開かれた場合は付けない）
    window.setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', '')
    }, DURATION)
    Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', 'false') })
    // 開く前に触っていた要素へ焦点を戻す
    if (lastFocused && lastFocused.focus) lastFocused.focus()
  }

  Array.prototype.forEach.call(openers, function (b) {
    b.addEventListener('click', function () { open(b) })
  })
  Array.prototype.forEach.call(closers, function (b) {
    b.addEventListener('click', close)
  })

  // Escキーでも閉じる
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close()
  })
})()

})(window.jQuery);